import { render, staticRenderFns } from "./inputBox.vue?vue&type=template&id=59422a5c&scoped=true&"
import script from "./inputBox.vue?vue&type=script&lang=js&"
export * from "./inputBox.vue?vue&type=script&lang=js&"
import style0 from "./inputBox.vue?vue&type=style&index=0&id=59422a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59422a5c",
  null
  
)

export default component.exports